/**
 * Returns the input URL string only if it parses as an absolute http(s) URL.
 *
 * Use this whenever a URL value originates outside the app (server response,
 * external integration, user input, imported data) and is about to be placed
 * into an `href`, `src`, or other navigable attribute. Without this gate, a
 * `javascript:` or `data:` URL could be turned into an XSS or open-redirect
 * vector.
 *
 * Returns `null` for relative URLs, non-http(s) schemes, or unparseable input.
 */
export function safeHttpUrl(value: string | null | undefined): string | null {
  if (!value) return null;
  try {
    const parsed = new URL(value);
    if (parsed.protocol === "http:" || parsed.protocol === "https:") {
      return parsed.toString();
    }
  } catch {
    // not a parseable URL
  }
  return null;
}
